import { Check, Copy } from "lucide-react";
import * as React from "react";

import { cn } from "@/lib/utils";

/** C25 批1(P8):代码/JSON 展示——极浅底 r8 + mono + 复制按钮 + 超高折叠(收编 pre+stringify 40+ 处)。 */
export function CodeBlock({
	code,
	maxHeight = 320,
	className,
}: {
	code: string;
	maxHeight?: number;
	className?: string;
}) {
	const [copied, setCopied] = React.useState(false);
	const [expanded, setExpanded] = React.useState(false);
	const long = code.split("\n").length > 12 || code.length > 800;
	return (
		<div className={cn("group relative rounded-lg bg-surface-subtle", className)}>
			<button
				type="button"
				onClick={() => {
					navigator.clipboard?.writeText(code).then(() => {
						setCopied(true);
						setTimeout(() => setCopied(false), 1500);
					});
				}}
				className="absolute right-2 top-2 z-10 flex h-7 w-7 items-center justify-center rounded-full bg-surface-card text-text-muted opacity-0 shadow-sm transition-opacity duration-150 hover:text-text-primary focus-visible:opacity-100 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-state-focus group-hover:opacity-100"
				aria-label="复制"
			>
				{copied ? (
					<Check className="h-3.5 w-3.5 text-brand-success" />
				) : (
					<Copy className="h-3.5 w-3.5" />
				)}
			</button>
			<pre
				className="overflow-auto whitespace-pre-wrap break-all p-3 font-mono text-xs leading-5 text-text-primary"
				style={expanded ? undefined : { maxHeight }}
			>
				{code}
			</pre>
			{long ? (
				<button
					type="button"
					onClick={() => setExpanded((v) => !v)}
					className="w-full rounded-b-lg border-t border-surface-border py-1 text-xs text-text-muted transition-colors duration-150 hover:bg-surface-muted hover:text-text-primary"
				>
					{expanded ? "收起 ∧" : "展开全部 ∨"}
				</button>
			) : null}
		</div>
	);
}

/** JSON 便捷包装 */
export function JsonBlock({ value, maxHeight }: { value: unknown; maxHeight?: number }) {
	return <CodeBlock code={JSON.stringify(value, null, 2)} maxHeight={maxHeight} />;
}
